var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/esn.calendar.libs/app/components/mail-to-attendees/mail-to-attendees.pug");
module.exports = (req['default'] || req).apply(req, [])